<div *ngIf="loading() && !whitelabelPendingApps()" class="main-container">
    <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <app-progress-spinner>
        </app-progress-spinner>
    </div>
</div>

<div *ngIf="(!loading() && !whitelabelPendingApps()) || (!loading() && whitelabelPendingApps().length === 0)" class="main-container">
    <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <app-emptysate></app-emptysate>
    </div>
</div>

<div *ngIf="!loading() && whitelabelPendingApps() && whitelabelPendingApps()?.length !== 0" class="input-group mb-2">       
    <span class="input-group-text fa-solid fa-magnifying-glass" id="basic-addon1"></span>
    <input [(ngModel)]="searchBarContent" type="text" class="form-control" placeholder="Nome do App ou Id do contador">
</div>

<table *ngIf="!loading() && whitelabelPendingApps() && whitelabelPendingApps()?.length!== 0" class="table">
    <thead>
        <tr>
            <th scope="col">Nome do Escritório</th>
            <th class="text-center" scope="col">Tem Ios</th>
            <th class="text-center" scope="col">Tem Android</th>
            <th class="text-center"></th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let appConfig of whitelabelPendingApps()">
            <td>
                {{ appConfig.accountantName }}
            </td>
            <td class="text-center">
                <i *ngIf="appConfig.hasIos" class="me-2 fa-solid fa-check"></i>
            </td>
            <td class="text-center">
                <i *ngIf="appConfig.hasAndroid" class="me-2 fa-solid fa-check"></i>
            </td>
            <td class="text-center">
                <i (click)="openInitConfigModal(appConfig)" *ngIf="appConfig.hasIos || appConfig.hasAndroid" matTooltip="Iniciar configuração" class="whitelabel-action fa-solid fa-play"></i>
            </td>
        </tr>
    </tbody>
</table>
